import XRSwiper from './swiper.vue';

export default XRSwiper


// WEBPACK FOOTER //
// ./src/components/swiper/swiperindex.js